
























import Vue from "vue";

import Menu from "@/components/common/Menu.vue";

import { commonModule } from "@/plugins/store-accessors";

export default Vue.extend({
  name: "app-footer",
  components: { Menu },
  computed: {
    year(): number {
      const date = new Date();
      return date.getFullYear();
    },
    contacts() {
      return commonModule.getContacts;
    },
  },
});
